import React from 'react';
import DriverMvp from './DriverMvp';
import DriverLegacy from './DriverLegacy';

/**
 * Driver Overview tab entry point. Behind the payment_platform_mvp Flipper flag it renders the
 * redesigned MVP layout (three summary cards + the read-only Fares Master preview table); with the
 * flag off it renders the unchanged legacy layout (six breakdown cards + the editable driver table).
 * All props from the Payments container are forwarded intact to whichever layout is active.
 *
 * @param {Object} props - Driver Overview props, including the payment_platform_mvp flag.
 * @returns {JSX.Element}
 */
const Driver = (props) =>
  (props.paymentPlatformMvp ? <DriverMvp {...props} /> : <DriverLegacy {...props} />);

export default Driver;
